import { Alert, AlertIcon } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import * as React from 'react';

import { usePermissions } from '@/hooks/usePermissions';
import { Loading } from '@/imports/ui/chakra/components/Loading';

interface NoAccessComponentProps {
  title?: string;
  message?: string;
}

export const NoAccessComponent: React.FC<NoAccessComponentProps> = ({ title, message }) => {
  const router = useRouter();
  const permissions = usePermissions();

  React.useEffect(() => {
    if (!permissions.isLoading && !permissions.isAuthenticated) {
      router.push({
        pathname: `/login`,
        query: {
          redirect: router.asPath,
        },
      });
    }
  }, [permissions.isLoading, router, permissions.isAuthenticated]);

  if (
    permissions.isLoading ||
    (!permissions.isLoading && !permissions.isAuthenticated)
  ) {
    return <Loading />;
  }

  return (
    <Alert status="error">
      <AlertIcon />
      {title ? <strong>{title}</strong> : null}
      {message ? <p>{message}</p> : <p>This content has been removed or the permissions were updated.</p>}
    </Alert>
  );
};
